import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useApi, useResource, errorText } from "@/lib/api";
import { useMe } from "@/components/AccessGate";
import InvitePanel from "@/components/InvitePanel";

const LABEL = { admin: "Approved director", pending: "Awaiting approval" };

export default function AccessPage() {
  const api = useApi();
  const me = useMe();
  const { data, reload } = useResource("/users");
  const setRole = async (u, role) => {
    try {
      await api("patch", `/users/${u.user_id}/role`, { role });
      toast.success(`${u.email} is now ${LABEL[role].toLowerCase()}`);
      reload();
    } catch (e) { toast.error(errorText(e)); }
  };

  return (
    <div className="rise">
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="admin-title">Admin · Director accounts</h1>
      <p className="mt-3 text-muted-foreground text-base md:text-lg">
        Invite new directors, and approve or remove access. Only approved directors can see the records.
      </p>
      <div className="mt-10"><InvitePanel onChange={reload} /></div>
      <div className="mt-6 border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm" data-testid="access-table">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="px-5 py-3 font-medium">Name</th><th className="px-5 py-3 font-medium">Email</th>
              <th className="px-5 py-3 font-medium">Status</th><th />
            </tr>
          </thead>
          <tbody>
            {(data?.users || []).map((u) => (
              <tr key={u.user_id} className="border-b border-border last:border-0" data-testid={`access-row-${u.email}`}>
                <td className="px-5 py-3">{u.name}</td>
                <td className="px-5 py-3 font-mono text-xs">{u.email}</td>
                <td className="px-5 py-3">{LABEL[u.role]}</td>
                <td className="px-5 py-3 text-right">
                  {u.email !== me?.email && (u.role === "admin" ? (
                    <Button variant="outline" size="sm" onClick={() => setRole(u, "pending")} data-testid={`access-revoke-${u.email}`}>Revoke</Button>
                  ) : (
                    <Button size="sm" onClick={() => setRole(u, "admin")} data-testid={`access-approve-${u.email}`}>Approve</Button>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
